/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { opexesOtheropexCopyCreate } from '../fn/opexs-other/opexes-otheropex-copy-create';
import { OpexesOtheropexCopyCreate$Params } from '../fn/opexs-other/opexes-otheropex-copy-create';
import { opexesOtheropexCreate } from '../fn/opexs-other/opexes-otheropex-create';
import { opexesOtheropexCreate$FormData } from '../fn/opexs-other/opexes-otheropex-create-form-data';
import { OpexesOtheropexCreate$FormData$Params } from '../fn/opexs-other/opexes-otheropex-create-form-data';
import { OpexesOtheropexCreate$Params } from '../fn/opexs-other/opexes-otheropex-create';
import { opexesOtheropexCreate$XWwwFormUrlencoded } from '../fn/opexs-other/opexes-otheropex-create-x-www-form-urlencoded';
import { OpexesOtheropexCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-other/opexes-otheropex-create-x-www-form-urlencoded';
import { opexesOtheropexDestroy } from '../fn/opexs-other/opexes-otheropex-destroy';
import { OpexesOtheropexDestroy$Params } from '../fn/opexs-other/opexes-otheropex-destroy';
import { opexesOtheropexEnumsRetrieve } from '../fn/opexs-other/opexes-otheropex-enums-retrieve';
import { OpexesOtheropexEnumsRetrieve$Params } from '../fn/opexs-other/opexes-otheropex-enums-retrieve';
import { opexesOtheropexList } from '../fn/opexs-other/opexes-otheropex-list';
import { OpexesOtheropexList$Params } from '../fn/opexs-other/opexes-otheropex-list';
import { opexesOtheropexPartialUpdate } from '../fn/opexs-other/opexes-otheropex-partial-update';
import { opexesOtheropexPartialUpdate$FormData } from '../fn/opexs-other/opexes-otheropex-partial-update-form-data';
import { OpexesOtheropexPartialUpdate$FormData$Params } from '../fn/opexs-other/opexes-otheropex-partial-update-form-data';
import { OpexesOtheropexPartialUpdate$Params } from '../fn/opexs-other/opexes-otheropex-partial-update';
import { opexesOtheropexPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-other/opexes-otheropex-partial-update-x-www-form-urlencoded';
import { OpexesOtheropexPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-other/opexes-otheropex-partial-update-x-www-form-urlencoded';
import { opexesOtheropexRetrieve } from '../fn/opexs-other/opexes-otheropex-retrieve';
import { OpexesOtheropexRetrieve$Params } from '../fn/opexs-other/opexes-otheropex-retrieve';
import { opexesOtheropexUpdate } from '../fn/opexs-other/opexes-otheropex-update';
import { opexesOtheropexUpdate$FormData } from '../fn/opexs-other/opexes-otheropex-update-form-data';
import { OpexesOtheropexUpdate$FormData$Params } from '../fn/opexs-other/opexes-otheropex-update-form-data';
import { OpexesOtheropexUpdate$Params } from '../fn/opexs-other/opexes-otheropex-update';
import { opexesOtheropexUpdate$XWwwFormUrlencoded } from '../fn/opexs-other/opexes-otheropex-update-x-www-form-urlencoded';
import { OpexesOtheropexUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-other/opexes-otheropex-update-x-www-form-urlencoded';
import { BackendOtherOpexDto } from '../models/backend-other-opex-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsOtherService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesOtheropexList()` */
  static readonly OpexesOtheropexListPath = '/api/opexes/otheropex/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexList$Response(
    params?: OpexesOtheropexList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOtherOpexDto>>> {
    return opexesOtheropexList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexList(
    params?: OpexesOtheropexList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOtherOpexDto>> {
    return this.opexesOtheropexList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendOtherOpexDto>>): Array<BackendOtherOpexDto> => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexCreate()` */
  static readonly OpexesOtheropexCreatePath = '/api/opexes/otheropex/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexCreate$Response(
    params: OpexesOtheropexCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexCreate(params: OpexesOtheropexCreate$Params, context?: HttpContext): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexCreate$XWwwFormUrlencoded$Response(
    params: OpexesOtheropexCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexCreate$XWwwFormUrlencoded(
    params: OpexesOtheropexCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexCreate$FormData$Response(
    params: OpexesOtheropexCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexCreate$FormData(
    params: OpexesOtheropexCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexRetrieve()` */
  static readonly OpexesOtheropexRetrievePath = '/api/opexes/otheropex/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexRetrieve$Response(
    params: OpexesOtheropexRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexRetrieve(
    params: OpexesOtheropexRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexUpdate()` */
  static readonly OpexesOtheropexUpdatePath = '/api/opexes/otheropex/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexUpdate$Response(
    params: OpexesOtheropexUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexUpdate(params: OpexesOtheropexUpdate$Params, context?: HttpContext): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexUpdate$XWwwFormUrlencoded$Response(
    params: OpexesOtheropexUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexUpdate$XWwwFormUrlencoded(
    params: OpexesOtheropexUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexUpdate$FormData$Response(
    params: OpexesOtheropexUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexUpdate$FormData(
    params: OpexesOtheropexUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexDestroy()` */
  static readonly OpexesOtheropexDestroyPath = '/api/opexes/otheropex/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexDestroy$Response(
    params: OpexesOtheropexDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesOtheropexDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexDestroy(params: OpexesOtheropexDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesOtheropexDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexPartialUpdate()` */
  static readonly OpexesOtheropexPartialUpdatePath = '/api/opexes/otheropex/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexPartialUpdate$Response(
    params: OpexesOtheropexPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesOtheropexPartialUpdate(
    params: OpexesOtheropexPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesOtheropexPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesOtheropexPartialUpdate$XWwwFormUrlencoded(
    params: OpexesOtheropexPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexPartialUpdate$FormData$Response(
    params: OpexesOtheropexPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesOtheropexPartialUpdate$FormData(
    params: OpexesOtheropexPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexCopyCreate()` */
  static readonly OpexesOtheropexCopyCreatePath = '/api/opexes/otheropex/{id}/copy/';

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexCopyCreate$Response(
    params: OpexesOtheropexCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
    return opexesOtheropexCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexCopyCreate(
    params: OpexesOtheropexCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOtherOpexDto> {
    return this.opexesOtheropexCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOtherOpexDto>): BackendOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `opexesOtheropexEnumsRetrieve()` */
  static readonly OpexesOtheropexEnumsRetrievePath = '/api/opexes/otheropex/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesOtheropexEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexEnumsRetrieve$Response(
    params: OpexesOtheropexEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesOtheropexEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesOtheropexEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesOtheropexEnumsRetrieve(params: OpexesOtheropexEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.opexesOtheropexEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
